<template>
  <div>
    <canvas
      id="canvas"
      v-on:mousedown="handleMouseDown"
      v-on:mouseup="handleMouseUp"
      v-on:mousemove="handleMouseMove"
      :width="width + 'px'"
      :height="width + 'px'"
    ></canvas>
    <div style="text-align:center" class="m-2">
      <b-button-group>
        <b-btn @click="predict" variant="secondary">
          Predict
        </b-btn>
        <b-btn @click="resetContext" variant="secondary">
          Reset
        </b-btn>
      </b-button-group>
    </div>
    <b-modal
      ref="preds-modal"
      title="Model predictions"
      hide-footer
    >
      <div class="mb-2">
        Click a row to see the pixels that contributed to the score of the digit (shown below the table).
        Light areas counted towards the digit score, while dark areas counted against it.
      </div>
      <b-table
        hover
        :items="preds"
        @row-clicked="rowClicked"
      ></b-table>
      <div style="text-align:center">
        <div id="explainImg"></div>
      </div>
      <div v-if="explainBusy" class="text-center text-primary mt-2">
        <b-spinner class="align-middle" />
      </div>
    </b-modal>
  </div>
</template>

<script>

import axios from 'axios';
import { endpoints } from '../../constants';

export default {
  name: "drawing-board",
  data() {
    return {
      width: 400,
      mouse: {
        current: {
          x: 0,
          y: 0,
        },
        previous: {
          x: 0,
          y: 0,
        },
        down: false
      },
      canvas: null,
      context: null,
      rect: null,
      preds: [],
      explainBusy: false,
    }
  },
  computed: {
    currentMouse() {
      return {
        x: this.mouse.current.x - this.rect.left,
        y: this.mouse.current.y - this.rect.top,
      };
    }
  },
  methods: {
    draw(event) {
      if (this.mouse.down ) {
        this.context.lineTo(this.currentMouse.x, this.currentMouse.y);
        this.context.strokeStyle = 'white';
        this.context.lineWidth = 40;
        this.context.lineCap = 'round';
        this.context.stroke();
      }
    },
    handleMouseDown(event) {
      this.mouse.down = true;
      this.mouse.current = {
        x: event.pageX,
        y: event.pageY,
      };
      this.context.moveTo(this.currentMouse.x, this.currentMouse.y);
    },
    handleMouseUp() {
      this.mouse.down = false;
    },
    handleMouseMove(event) {
      this.mouse.current = {
        x: event.pageX,
        y: event.pageY,
      };
      this.draw(event);
    },
    resetContext() {
      this.context.beginPath();
      this.context.clearRect(0, 0, this.width, this.width);
    },
    async predict() {
      const imgData = this.canvas.toDataURL();
      const resp = await axios.post(endpoints.mnistPredict, {'data_uri': imgData});
      this.preds = resp.data.preds;
      this.$refs['preds-modal'].show();
    },
    async rowClicked(record) {
      this.explainBusy = true;
      const imgData = this.canvas.toDataURL();
      const resp = await axios.post(
        endpoints.mnistExplain,
        {'data_uri': imgData, 'target': record.target},
      );
      let src = "data:image/jpeg;base64,";
      src += resp.data;
      const newImage = document.createElement('img');
      newImage.src = src;
      newImage.width = newImage.height = "200";
      document.querySelector('#explainImg').innerHTML = newImage.outerHTML;
      this.explainBusy = false;
    },
  },
  mounted: function () {
    this.canvas = document.getElementById("canvas");
    this.context = this.canvas.getContext('2d');
    this.rect = this.canvas.getBoundingClientRect();
    this.context.imageSmoothingEnabled= false;
  },
}
</script>

<style scoped>
  #canvas {
    background: #2c3e50;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
</style>
